module.exports = __webpack_public_path__ + "static/MD-48f424c1d4d88c8f2b7d2b5b09352108.svg";